/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';

import Config from 'config';
import { getCSRFToken, getLoading } from '../modules/session/getters';

type Props = {
  children: AnyMap,
  csrfToken?: string,
  sessionLoading: boolean
};

const withStore: Function = connect((state): { csrfToken: string } => ({
  sessionLoading: getLoading(state),
  csrfToken: getCSRFToken(state)
}));

const createApolloClient: Function = (csrfToken: string) => {
  return new ApolloClient({
    networkInterface: createNetworkInterface({
      uri: `${Config.api.host}/graphql/beta`,
      opts: {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }
    })
  });
};

class WithClient extends React.Component<void, Props, void> {
  render() {
    const { csrfToken, sessionLoading, children } = this.props;

    if (sessionLoading) {
      return null;
    }

    return (
      <ApolloProvider client={createApolloClient(csrfToken)}>
        {children}
      </ApolloProvider>
    );
  }
}

export default withStore(WithClient);



// WEBPACK FOOTER //
// ./src/components/with-apollo.js